<template>
  <div class="text-left">
    <div class="flex">
      <div class="w-1/2 bg-white p-6">
        <div class="text-c14 text-bd">
          Fournisseur
        </div>

     
        <div class="flex w-1/2 items-center mt-4">
          <icon
            :data="icons.company"
            height="20"
            width="20"
            class="cursor-pointer"
            original
          />
          <div class="ml-4 w-3/5 text-c20 font-c6">
            CONNANT
          </div>
        </div>

        <div class="flex text-c14 mt-4">
          <div class="text-90">
            Date de facturation :
          </div>
          <div class="">
            12-11-2021
          </div>
        </div>

        <div class="flex text-c14 mt-4">
          <div class="text-90">
            Référence :
          </div>
          <div class="">
            696q970q
          </div>
        </div>
      </div>

      <div class="w-1/2 bg-white p-6 ml-6">
        <div class="flex text-c14">
          <div class="w-1/2 flex items-center">
            <div class="text-60">
              Réception :
            </div>

            <div class="w-2/5 ml-2">
              <boutton
                label="En attente"
                background="#FFF6E6"
                color="#FBA705"
                height="28px"
                size="13px"
              />
            </div>
          </div>

          <div class="w-1/2 flex items-center justify-end pr-6">
            <div class="text-60">
              Date :
            </div>

            <div class="ml-2">
              12-11-2021, 15h21
            </div>
          </div>
        </div>

        <div class="flex text-c14 mt-4">
          <div class="text-60">
            Quantité total :
          </div>
          <div class="">
            1069
          </div>
        </div>

        <div class="flex text-c14 mt-4">
          <div class="text-60">
            Date de réception :
          </div>
          <div class="ml-2">
            12-11-2021, 15h21 <span class="ml-2">|</span> <span class="text-oho-blue ml-2">Samuel H</span> 
          </div>
        </div>

        <div class="flex text-c14 mt-4">
          <div class="w-1/2 flex items-center">
            <div class="text-60">
              Service :
            </div>

            <div class="ml-2">
              Comptabilité
            </div>
          </div>

          <div class="w-1/2 flex items-center pr-6 justify-end">
            <div class="text-60">
              Auteur :
            </div>

            <div class="ml-2 flex">
              <namelabel
                first="D"
                second="M"
                height="24px"
                width="24px"
                size="9px"
              />
              <div class="ml-2">
                Dwayne Michael
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import company from '../../../assets/icons/company.svg'
import boutton from '../../helper/add/button.vue'
import namelabel from '../../helper/add/nameLabel.vue'

export default {
  name: "Index",

  components: {
    boutton,
    namelabel
  },
  props: {
    donnes: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      icons: {
        company
      },
      
    }
  },

  computed: {
    
  },

  created () {
   
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/sass/variables.scss";
.svg-icon {
  fill: transparent;
}
</style>
